// RolesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { httpinstance } from '../../axios/api';

// Step 1: Create an async thunk for the GET request
export const fetchData = createAsyncThunk('data/fetchData', async (_, { rejectWithValue }) => {
  try {
    console.log('Fetching data...');
    const response = await httpinstance.get('/user-details');
    console.log('response', response);
    return response.data; // This will be the payload for the fulfilled action
  } catch (error) {
    return rejectWithValue(error.response.data); // Pass the error to the rejected action
  }
});

// Step 2: Create the slice
const dataSlice = createSlice({
  name: 'data',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dataSlice.reducer;
